import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

export const FeatureContainer = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const FeatureLabel = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.regular};
  white-space: nowrap;
`;

export const FeatureIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: ${(props) => props.theme.colors.primary};
`;

export const MainFeatureIcon = styled(FeatureIcon)`
  margin: 0 4px;
`;
